import Container from "./Container";
import { useRef, useEffect } from "react";
import { gsap } from "../../lib/gsap";

export default function Footer() {
  const footerRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      footerRef.current,
      { opacity: 0, y: 60 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: footerRef.current,
          start: "top 95%",
        },
      }
    );
  }, []);

  return (
    <footer
      ref={footerRef}
      className="relative bg-slate-950 text-white pt-32 pb-20 border-t border-slate-800 overflow-hidden"
    >
      {/* Subtle depth gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 pointer-events-none" />

      <Container>
        <div className="relative">

          {/* Main Grid */}
          <div className="grid md:grid-cols-4 gap-20 mb-24">

            {/* Brand */}
            <div>
              <h3 className="text-2xl font-semibold mb-6 tracking-tight">
                NE
                <span className="text-[color:var(--color-accent)]">
                  ORAQ
                </span>
              </h3>

              <p className="text-slate-400 leading-relaxed text-sm max-w-xs">
                Engineering real-time autonomous intelligence
                systems for scalable deployment across global
                mobility ecosystems.
              </p>
            </div>

            {/* Technology */}
            <div>
              <h4 className="text-xs uppercase tracking-widest text-slate-500 mb-6">
                Technology
              </h4>

              <ul className="space-y-4 text-slate-400 text-sm">
                {[
                  "Perception Stack",
                  "Predictive Intelligence",
                  "Deterministic Control",
                  "Fleet Synchronization",
                ].map((item, i) => (
                  <li key={i} className="group cursor-pointer">
  <span className="relative inline-block text-slate-400 group-hover:text-white transition-colors duration-300">
    {item}
    <span className="absolute left-0 -bottom-1 h-[1px] w-0 bg-[color:var(--color-accent)] transition-all duration-300 group-hover:w-full" />
  </span>
</li>
                ))}
              </ul>
            </div>

            {/* Industries */}
            <div>
              <h4 className="text-xs uppercase tracking-widest text-slate-500 mb-6">
                Industries
              </h4>

              <ul className="space-y-4 text-slate-400 text-sm">
                {[
                  "Autonomous Vehicles",
                  "Smart Infrastructure",
                  "Urban Mobility",
                  "Industrial Automation",
                ].map((item, i) => (
                  <li key={i} className="group cursor-pointer">
  <span className="relative inline-block text-slate-400 group-hover:text-white transition-colors duration-300">
    {item}
    <span className="absolute left-0 -bottom-1 h-[1px] w-0 bg-[color:var(--color-accent)] transition-all duration-300 group-hover:w-full" />
  </span>
</li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-xs uppercase tracking-widest text-slate-500 mb-6">
                Contact
              </h4>

              <ul className="space-y-4 text-slate-400 text-sm">
                <li className="hover:text-white transition-colors duration-300">
                  info@citriot.com
                </li>
                <li className="hover:text-white transition-colors duration-300">
                  Global Operations
                </li>
                <li className="hover:text-white transition-colors duration-300">
                  Enterprise Partnerships
                </li>
              </ul>
            </div>

          </div>

          {/* Bottom Bar */}
          <div className="pt-10 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center text-slate-500 text-sm">

            <p>
              © {new Date().getFullYear()} NEORAQ Autonomous Systems.
              All rights reserved.
            </p>
            <p>
               Powered by Citriot. In Association with HKBK
            </p>
            <div className="flex gap-10 mt-6 md:mt-0">
              {["Privacy Policy", "Terms of Service", "Compliance"].map(
                (item, i) => (
                  <span
                    key={i}
                    className="relative group cursor-pointer"
                  >
                    <span className="group-hover:text-white transition-colors duration-300">
                      {item}
                    </span>
                    <span className="absolute left-0 -bottom-1 w-0 h-[1px] bg-[color:var(--color-accent)] transition-all duration-300 group-hover:w-full" />
                  </span>
                )
              )}
            </div>

          </div>
        </div>
      </Container>
    </footer>
  );
}